module.exports = __webpack_public_path__ + "static/media/banner.48da8cc6.png";